import { useGetPaymentFees } from '@/apis/payments/hooks/useGetPaymentFees'
import MultiQueryPageLoader from '@/app/common/components/PageLoader/MultiQueryPageLoader'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { SelectedPurse } from '@/storage/applications/providerPaySlice'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { useSelector } from 'react-redux'
import { useStudentPurses } from '../../api/usePaymentProviders'
import { PurseFormData, PurseSelectionForm } from './choose_purses_form'

type Props = {
  amount: number
  purses: SelectedPurse[]
  onNext: (selectedPurses: SelectedPurse[]) => void
  onBack: () => void
}

export const ChoosePurses = (props: Props) => {
  const { amount, purses, onBack, onNext } = props
  const programId = useSelector(selectProgramID)
  const application = useSelector(selectFamilyApplication)
  const studentPurseQuery = useStudentPurses({
    program_id: programId,
    application_id: application.application_id,
  })

  const onSubmit = async (purses: PurseFormData) => {
    const selectedPurses = purses.purses.filter((purse) => purse.isSelected)
    onNext(selectedPurses)
  }



  const paymentFeeQuery = useGetPaymentFees({
    base_amount: amount,
    program_id: programId,
  })

  return (
    <MultiQueryPageLoader
      queries={[studentPurseQuery, paymentFeeQuery] as const}
    >
      {([purseData, paymentFees]) => {
        console.log(paymentFees)
        return (
          <PurseSelectionForm
            serviceFeeInformation={paymentFees}
            selectedPurses={purses}
            apiPurses={purseData}
            onSubmit={onSubmit}
            onBack={onBack}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}
